export default "__VITE_ASSET__xFQJrhMj__"